export const MAX_CHART_HEIGHT = 400;
